import { Button } from '@salesforce/design-system-react';
import classnames from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { AppDispatch } from '../../../app/store';

import styles from './Buttons.module.scss';
import { requestNewReport, selectCodeScanStatus } from '../dashboardSlice';
import { CodeScanStatus } from '../types';

type ReScanButtonProps = {
  className?: string | undefined;
};

export const ReScanButton: React.FC<ReScanButtonProps> = ({ className }) => {
  const dispatch: AppDispatch = useAppDispatch();
  const navigate = useNavigate();
  const codeScanStatus = useAppSelector(selectCodeScanStatus);

  const onRescan = async () => {
    await dispatch(requestNewReport());
    navigate(`/`);
  };

  const classes = classnames(styles.ReScanButton, className);
  const isDisable = codeScanStatus === CodeScanStatus.Started;

  return (
    <Button disabled={isDisable} className={classes} label='Re-scan your org' variant='brand' onClick={onRescan} />
  );
}
